import Api from 'App/api'
import { localStorage as local } from '@entrata/utils'
import { JWT_STORAGE_KEY } from 'portal-modules/common/constants/keys'
import { getSessionCookies } from 'portal-utils/session-cookies'

//Attention: This is a duplicate in ledger module as well. Keep only one
export const getLedger = Api.get({
  controller: 'ledger',
  action: 'getLedger',
})

export const getAvailablePaymentTypes = Api.get({
  controller: 'payments',
  action: 'getAvailablePaymentTypes',
})

// Auto payments
export const getScheduledPaymentSettings = Api.get({
  controller: 'scheduled_payments',
  action: 'getSettings',
})

export const postScheduledPayment = Api.post({
  controller: 'scheduled_payments',
  action: 'save',
})

export const approveScheduledPayment = Api.post({
  controller: 'scheduled_payments',
  action: 'approveSplit',
})

export const getScheduledPayments = Api.get({
  controller: 'scheduled_payments',
  action: 'listWithSettings',
})

export const deleteScheduledPayment = Api.post({
  controller: 'scheduled_payments',
  action: 'delete',
})

// Payment Accounts
export const savePaymentMethod = Api.post({
  controller: 'payment_accounts',
  action: 'add',
})

export const updatePaymentAccount = Api.post({
  controller: 'payment_accounts',
  action: 'update',
})

export const getPaymentMethods = Api.get({
  controller: 'payment_accounts',
  action: 'list',
})

export const getPaymentMethodWithSettings = Api.get({
  controller: 'payment_accounts',
  action: 'listWithSettings',
})

export const deletePaymentAccount = Api.post({
  controller: 'payment_accounts',
  action: 'delete',
})

export const getPaymentAccounts = Api.get({
  controller: 'payment_accounts',
  action: 'list',
})

export const authCapturePayment = Api.post({
  controller: 'payments',
  action: 'authCapture',
})

export const getPaymentSettings = Api.get({
  controller: 'payments',
  action: 'getSettings',
})

// Bank name from routing number
export const getBankName = Api.get({
  controller: 'payments',
  action: 'getBankName',
})

export const cancelPayment = Api.post({
  controller: 'payments',
  action: 'cancel',
})
// Money Gram
export const getMoneyGram = Api.get({
  controller: 'moneygram',
  action: 'get',
})

export const getMoneyGramInstructions = showSpanishInstruction =>
  Api.getUrl(
    { controller: 'moneygram', action: 'getInstructions' },
    { token: getSessionCookies(JWT_STORAGE_KEY), showSpanishInstruction },
  )

export const addMoneyGramAccount = Api.post({
  controller: 'moneygram',
  action: 'create',
})

// Re-payments
export const getRepaymentHistoryData = Api.get({
  controller: 'repayments',
  action: 'history',
})

export const getRepaymentList = Api.get({
  controller: 'repayments',
  action: 'list',
})

// Refund Module
export const getRefundAccountWithSettings = Api.get({
  controller: 'refund_accounts',
  action: 'listWithSettings',
})

export const deleteRefundAccount = Api.post({
  controller: 'refund_accounts',
  action: 'delete',
})

export const saveRefundAccount = Api.post({
  controller: 'refund_accounts',
  action: 'add',
})

export const saveCustomerPlaidItem = Api.post({
  controller: 'customer_plaid_items',
  action: 'save',
})

export const getPlaidInactiveAccounts = Api.get({
  controller: 'customer_plaid_items',
  action: 'getInactiveAccounts',
})

export const createPublicToken = Api.post({
  controller: 'customer_plaid_items',
  action: 'createPublicToken',
})

export const getMoneygramSettings = Api.get({
  controller: 'moneygram',
  action: 'getWithSettings',
})

export const getScheduledPaymentList = Api.get({
  controller: 'scheduled_payments',
  action: 'list',
})
